"use client";

import { FinancingVideoShowcase } from "@/components/blocks/financing-video-showcase";
import type { FinancingVideoEpisode } from "@/components/blocks/financing-video-showcase";
import { cn } from "@/lib/utils";

import { CTA_HREF, muxThumbnailUrl, VIDEOS } from "./data";
import { GrowingBand } from "./section-shell";

interface GrowingVideoShowcaseProps {
  title: string;
  ctaLabel: string;
  className?: string;
}

function toFinancingEpisodes(): FinancingVideoEpisode[] {
  return VIDEOS.map((video) => ({
    id: video.slug,
    playbackId: video.playbackId,
    title: video.title,
    storyLabel: video.storyLabel,
    href: video.storyHref,
    thumbnailUrl: muxThumbnailUrl(video.playbackId),
  }));
}

export function GrowingVideoShowcase({
  title,
  ctaLabel,
  className,
}: GrowingVideoShowcaseProps) {
  return (
    <GrowingBand
      className={cn("overflow-x-clip", className)}
      data-section="growing-video"
    >
      <FinancingVideoShowcase
        title={title}
        ctaLabel={ctaLabel}
        ctaHref={CTA_HREF}
        ctaExternal
        episodes={toFinancingEpisodes()}
        dataTestId="video-carousel-section"
      />
    </GrowingBand>
  );
}
